var map = {
	"./monster/arachas1.png": "NoWg",
	"./monster/arachas2.png": "OXlA",
	"./monster/arachas3.png": "w3Im",
	"./monster/arachas_behemoth.png": "6zLt",
	"./monster/botchling.png": "0hbv",
	"./monster/celaeno_harpy.png": "RRKK",
	"./monster/cockatrice.png": "733F",
	"./monster/crone_brewess.png": "nxoH",
	"./monster/crone_weavess.png": "f6zg",
	"./monster/crone_whispess.png": "DUux",
	"./monster/draug.png": "0xx3",
	"./monster/earth_elemental.png": "equx",
	"./monster/endrega.png": "NGfs",
	"./monster/eredin_bringer.png": "rXb4",
	"./monster/eredin_commander.png": "pNd9",
	"./monster/eredin_destroyer.png": "H2Yk",
	"./monster/eredin_king.png": "ihEE",
	"./monster/fiend.png": "zq95",
	"./monster/fire_elemental.png": "x38B",
	"./monster/foglet.png": "J2CO",
	"./monster/forktail.png": "+ovj",
	"./monster/frightener.png": "XL7/",
	"./monster/gargoyle.png": "eCIp",
	"./monster/ghoul1.png": "c3Ej",
	"./monster/ghoul2.png": "UUfv",
	"./monster/ghoul3.png": "LwGQ",
	"./monster/grave_hag.png": "Z6Mo",
	"./monster/griffin.png": "3ute",
	"./monster/harpy.png": "p6Yf",
	"./monster/ice_giant.png": "Wf8d",
	"./monster/imlerith.png": "NAr3",
	"./monster/kayran.png": "LjgZ",
	"./monster/leshen.png": "0iMO",
	"./monster/nekker1.png": "DXJF",
	"./monster/nekker2.png": "x6OL",
	"./monster/nekker3.png": "fGvZ",
	"./monster/plague_maiden.png": "WnTr",
	"./monster/vampire_bruxa.png": "VkVl",
	"./monster/vampire_ekimmara.png": "CyaM",
	"./monster/vampire_fleder.png": "bS6k",
	"./monster/vampire_garkain.png": "4Ruq",
	"./monster/vampire_katakan.png": "AgeD",
	"./monster/werewolf.png": "R9G3",
	"./monster/wyvern.png": "y6ry",
	"./neutral/avallach.png": "g6NM",
	"./neutral/ciri.png": "joC/",
	"./neutral/clear.png": "44Oo",
	"./neutral/dandelion.png": "2Dqc",
	"./neutral/decoy.png": "uUni",
	"./neutral/emiel.png": "yiRT",
	"./neutral/fog.png": "rLoI",
	"./neutral/frost.png": "cbMc",
	"./neutral/geralt.png": "kQCg",
	"./neutral/horn.png": "HOvq",
	"./neutral/rain.png": "S11C",
	"./neutral/scorch.png": "y3Gh",
	"./neutral/triss.png": "gIq2",
	"./neutral/vesemir.png": "YoiV",
	"./neutral/villentretenmerth.png": "48qQ",
	"./neutral/yen.png": "LQ2o",
	"./neutral/zoltan.png": "I/x2",
	"./nilfgaardian/albrich.png": "kgMO",
	"./nilfgaardian/assire_var_anahid.png": "unFT",
	"./nilfgaardian/aux_archers1.png": "zi+A",
	"./nilfgaardian/aux_archers2.png": "a9ip",
	"./nilfgaardian/black_infantry_archer1.png": "6YEe",
	"./nilfgaardian/black_infantry_archer2.png": "EwMu",
	"./nilfgaardian/ceallach.png": "LQ7E",
	"./nilfgaardian/cynthia.png": "NzMz",
	"./nilfgaardian/eggebracht.png": "zhvc",
	"./nilfgaardian/emhyr_emperor.png": "T/dl",
	"./nilfgaardian/emhyr_imperial.png": "Y/uB",
	"./nilfgaardian/emhyr_relentless.png": "XKH0",
	"./nilfgaardian/emhyr_white.png": "1Dri",
	"./nilfgaardian/fire_scorpion.png": "eFer",
	"./nilfgaardian/heavy_fire_scorpion.png": "bj0m",
	"./nilfgaardian/impera_brigade_guard.png": "eOpz",
	"./nilfgaardian/letho.png": "oms9",
	"./nilfgaardian/menno.png": "qDDz",
	"./nilfgaardian/morteisen.png": "2/Ke",
	"./nilfgaardian/nausicaa_cavalry_rider.png": "USCG",
	"./nilfgaardian/puttkammer.png": "mP3Y",
	"./nilfgaardian/rainfarn.png": "yNWP",
	"./nilfgaardian/renauld.png": "BJra",
	"./nilfgaardian/rotten_mangonel.png": "5tKx",
	"./nilfgaardian/shilard.png": "Yifv",
	"./nilfgaardian/siege_engineer.png": "YZuy",
	"./nilfgaardian/siege_tech.png": "5f13",
	"./nilfgaardian/stefan_skellen.png": "G+1S",
	"./nilfgaardian/sweers.png": "KxMD",
	"./nilfgaardian/vanhemar.png": "IOST",
	"./nilfgaardian/vattier.png": "FYTH",
	"./nilfgaardian/vigo.png": "OnDf",
	"./nilfgaardian/voorhis.png": "YNow",
	"./nilfgaardian/vreemde.png": "y3H1",
	"./nilfgaardian/young_emissary1.png": "Icq7",
	"./nilfgaardian/young_emissary2.png": "3kx8",
	"./northern/ballista1.png": "sjJw",
	"./northern/ballista2.png": "NA8B",
	"./northern/catapult.png": "ygmQ",
	"./northern/commando.png": "CzxX",
	"./northern/crinfrid.png": "WD6M",
	"./northern/dethmold.png": "i99l",
	"./northern/dijkstra.png": "0U/1",
	"./northern/eilhart.png": "FeEy",
	"./northern/foltest_commander.png": "lmy7",
	"./northern/foltest_forged.png": "J+vK",
	"./northern/foltest_king.png": "lGzx",
	"./northern/foltest_siege.png": "XVM5",
	"./northern/foot_soldier1.png": "arCk",
	"./northern/foot_solider2.png": "W52z",
	"./northern/infantry.png": "tJB3",
	"./northern/keira.png": "CMD9",
	"./northern/medic.png": "KkMw",
	"./northern/natalis.png": "bI07",
	"./northern/roche.png": "ZKcH",
	"./northern/sabrina.png": "YJ2n",
	"./northern/siege_expert1.png": "+ktL",
	"./northern/siege_expert2.png": "++ag",
	"./northern/siege_expert3.png": "gfPb",
	"./northern/siege_tower.png": "lkwm",
	"./northern/siegfried.png": "9reW",
	"./northern/sile.png": "xPis",
	"./northern/skaggs.png": "Wt2M",
	"./northern/stennis.png": "2bcY",
	"./northern/thaler.png": "wF+N",
	"./northern/thyssen.png": "/ic+",
	"./northern/trebuchet1.png": "Kf8b",
	"./northern/trebuchet2.png": "V0A/",
	"./northern/ves.png": "1SN1",
	"./northern/yarpen.png": "1Xqg",
	"./scoiatael/archer.png": "hqaa",
	"./scoiatael/barclay.png": "+c3D",
	"./scoiatael/cranmer.png": "nS+L",
	"./scoiatael/defender1.png": "n/on",
	"./scoiatael/defender2.png": "zo4R",
	"./scoiatael/defender3.png": "Y9Lb",
	"./scoiatael/defender4.png": "fzRW",
	"./scoiatael/defender5.png": "8FfR",
	"./scoiatael/easnillien.png": "kJUB",
	"./scoiatael/eithne.png": "xi4L",
	"./scoiatael/elven_skirmisher1.png": "OOMg",
	"./scoiatael/elven_skirmisher2.png": "xkAM",
	"./scoiatael/elven_skirmisher3.png": "9ZqQ",
	"./scoiatael/fidhail.png": "THK3",
	"./scoiatael/francesca_beautiful.png": "0Te3",
	"./scoiatael/francesca_daisy.png": "VddB",
	"./scoiatael/francesca_pureblood.png": "Lq/l",
	"./scoiatael/francesca_queen.png": "Q7JK",
	"./scoiatael/healer.png": "7ix9",
	"./scoiatael/healer2.png": "39Vm",
	"./scoiatael/healer3.png": "xt9B",
	"./scoiatael/iorveth.png": "Z7gS",
	"./scoiatael/isengrim.png": "oIzU",
	"./scoiatael/milva.png": "NOI3",
	"./scoiatael/recruit.png": "70oY",
	"./scoiatael/riordain.png": "PA8m",
	"./scoiatael/saesenthessis.png": "VXF7",
	"./scoiatael/scout1.png": "pq9W",
	"./scoiatael/scout2.png": "YiUy",
	"./scoiatael/scout3.png": "xUaH",
	"./scoiatael/sivney.png": "Vxfp",
	"./scoiatael/skirmisher1.png": "+2j6",
	"./scoiatael/skirmisher2.png": "ZnDx",
	"./scoiatael/skirmisher3.png": "OiVS",
	"./scoiatael/smuggler1.png": "nRqE",
	"./scoiatael/smuggler2.png": "XP97",
	"./scoiatael/smuggler3.png": "Hoql",
	"./scoiatael/toruviel.png": "YmRC",
	"./scoiatael/veteran1.png": "iN9f",
	"./scoiatael/veteran2.png": "6jgB",
	"./scoiatael/yaevinn.png": "oieH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Qn/q";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards ^\.\/.*\.png$
// module id = Qn/q
// module chunks = 0